import type { IconProps } from '../types/IconProps.ts';
export const Annoyed: IconProps = {
    name: 'Annoyed',
    children: [
        `<path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20M8 15h8M8 9h2M14 9h2" />`,
    ]
};